/* eslint-disable-next-line */
import { API_CONFIG } from './apiConfig';
/* eslint-disable-next-line */
import { msalInstance } from './auth/msalInstance';
/* eslint-disable-next-line */
import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-common';
/* eslint-disable-next-line */
import { useCookiesStore } from '../stores/cookieStore';
import { ApiClientBase } from './apiClientBase';
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v1.0.0.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class CropConnectApiClient extends ApiClientBase {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();
   

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    getAnalyticsContextData(signal?: AbortSignal): Promise<AnalyticsContextDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Analytics";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAnalyticsContextData(_response);
        });
    }

    protected processGetAnalyticsContextData(response: AxiosResponse): Promise<AnalyticsContextDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AnalyticsContextDtoCropConnectApiResponse>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = JSON.parse(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AnalyticsContextDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Sends the OTP message to user
     * @param body (optional) 
     * @return OK
     */
    otp(body: SendOtpEmailRequestBody | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/otp";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOtp(_response);
        });
    }

    protected processOtp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the B2C user ID associated with the provided email.
     * @param body (optional) The request body containing the email address.
     * @return OK
     */
    id(body: ObjectIdRequestBody | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/id";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processId(_response);
        });
    }

    protected processId(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentBusinessPartnerMetadata(signal?: AbortSignal): Promise<BusinessPartnerDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/BusinessPartner/masterdata";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentBusinessPartnerMetadata(_response);
        });
    }

    protected processGetCurrentBusinessPartnerMetadata(response: AxiosResponse): Promise<BusinessPartnerDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BusinessPartnerDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessPartnerDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentBusinessPartnerExtendedMetadata(signal?: AbortSignal): Promise<BusinessPartnerMasterdataDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/BusinessPartner/extendedMasterdata";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentBusinessPartnerExtendedMetadata(_response);
        });
    }

    protected processGetCurrentBusinessPartnerExtendedMetadata(response: AxiosResponse): Promise<BusinessPartnerMasterdataDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BusinessPartnerMasterdataDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BusinessPartnerMasterdataDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param aob (optional) 
     * @return OK
     */
    switchBusinessPartner(bpNumber: string, aob: boolean | undefined, signal?: AbortSignal): Promise<CropConnectUserDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/BusinessPartner/switchBP/{bpNumber}?";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (aob === null)
            throw new Error("The parameter 'aob' cannot be null.");
        else if (aob !== undefined)
            url_ += "aob=" + encodeURIComponent("" + aob) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSwitchBusinessPartner(_response);
        });
    }

    protected processSwitchBusinessPartner(response: AxiosResponse): Promise<CropConnectUserDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the range of business partners numbers accessible for given user
     * @return OK
     */
    getAccessibleBusinessPartnersRange(signal?: AbortSignal): Promise<AccessibleBusinessPartnerRangeDtoArrayCropConnectApiResponse> {
        let url_ = this.baseUrl + "/BusinessPartner/accessible";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccessibleBusinessPartnersRange(_response);
        });
    }

    protected processGetAccessibleBusinessPartnersRange(response: AxiosResponse): Promise<AccessibleBusinessPartnerRangeDtoArrayCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AccessibleBusinessPartnerRangeDtoArrayCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccessibleBusinessPartnerRangeDtoArrayCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    finishAccessOnBehalf(signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/BusinessPartner/finishaob";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFinishAccessOnBehalf(_response);
        });
    }

    protected processFinishAccessOnBehalf(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BooleanCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the consultants for given Agricenter
     * @return OK
     */
    getConsultantsByAgriCenter(agricenterId: string, signal?: AbortSignal): Promise<AgricenterWithConsultantListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Consultant/agricenter/{agricenterId}";
        if (agricenterId === undefined || agricenterId === null)
            throw new Error("The parameter 'agricenterId' must be defined.");
        url_ = url_.replace("{agricenterId}", encodeURIComponent("" + agricenterId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConsultantsByAgriCenter(_response);
        });
    }

    protected processGetConsultantsByAgriCenter(response: AxiosResponse): Promise<AgricenterWithConsultantListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AgricenterWithConsultantListDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgricenterWithConsultantListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Deletes given Agricenter
     * @return Created
     */
    deleteConsultantFactory(agricenterId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Consultant/agricenter/{agricenterId}";
        if (agricenterId === undefined || agricenterId === null)
            throw new Error("The parameter 'agricenterId' must be defined.");
        url_ = url_.replace("{agricenterId}", encodeURIComponent("" + agricenterId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConsultantFactory(_response);
        });
    }

    protected processDeleteConsultantFactory(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets consultant for given Agricenter. Includes also the SapId's
     * @return OK
     */
    getConsultantsByAgriCenterAdmin(agricenterId: string, signal?: AbortSignal): Promise<AgricenterWithConsultantListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Consultant/agricenteradmin/{agricenterId}";
        if (agricenterId === undefined || agricenterId === null)
            throw new Error("The parameter 'agricenterId' must be defined.");
        url_ = url_.replace("{agricenterId}", encodeURIComponent("" + agricenterId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConsultantsByAgriCenterAdmin(_response);
        });
    }

    protected processGetConsultantsByAgriCenterAdmin(response: AxiosResponse): Promise<AgricenterWithConsultantListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AgricenterWithConsultantListDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgricenterWithConsultantListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Adds or updates consultant for given agricenter
     * @param body (optional) 
     * @return No Content
     */
    addOrUpdateConsultant(body: AddOrUpdateConsultantParameters | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Consultant/add";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddOrUpdateConsultant(_response);
        });
    }

    protected processAddOrUpdateConsultant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads picture for the consultant
     * @param file (optional) 
     * @return OK
     */
    uploadConsultantPicture(agricenterId: string, sapUserId: string, file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Consultant/agricenteradmin/{agricenterId}/{sapUserId}";
        if (agricenterId === undefined || agricenterId === null)
            throw new Error("The parameter 'agricenterId' must be defined.");
        url_ = url_.replace("{agricenterId}", encodeURIComponent("" + agricenterId));
        if (sapUserId === undefined || sapUserId === null)
            throw new Error("The parameter 'sapUserId' must be defined.");
        url_ = url_.replace("{sapUserId}", encodeURIComponent("" + sapUserId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadConsultantPicture(_response);
        });
    }

    protected processUploadConsultantPicture(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Adds new Agricenter
     * @param body (optional) 
     * @return OK
     */
    addNewConsultantFactories(body: AddNewConsultantAgricenterParameters | undefined, signal?: AbortSignal): Promise<AgricentersDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Consultant/agricenter/add";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddNewConsultantFactories(_response);
        });
    }

    protected processAddNewConsultantFactories(response: AxiosResponse): Promise<AgricentersDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AgricentersDtoCropConnectApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgricentersDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Deletes consultant from given AgriCenter
     * @param agricenterId (optional) 
     * @return Created
     */
    deleteConsultant(sapUserId: string, agricenterId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/Consultant/{sapUserId}?";
        if (sapUserId === undefined || sapUserId === null)
            throw new Error("The parameter 'sapUserId' must be defined.");
        url_ = url_.replace("{sapUserId}", encodeURIComponent("" + sapUserId));
        if (agricenterId === null)
            throw new Error("The parameter 'agricenterId' cannot be null.");
        else if (agricenterId !== undefined)
            url_ += "agricenterId=" + encodeURIComponent("" + agricenterId) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConsultant(_response);
        });
    }

    protected processDeleteConsultant(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getCurrentContext(signal?: AbortSignal): Promise<ContextDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Context";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentContext(_response);
        });
    }

    protected processGetCurrentContext(response: AxiosResponse): Promise<ContextDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ContextDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContextDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets databox data with average beet price data for invocation context
     * @return OK
     */
    getAverageBeetPriceDataBox(signal?: AbortSignal): Promise<AverageBeetPriceDataBoxDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DataBox/AverageBeetPrice";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAverageBeetPriceDataBox(_response);
        });
    }

    protected processGetAverageBeetPriceDataBox(response: AxiosResponse): Promise<AverageBeetPriceDataBoxDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AverageBeetPriceDataBoxDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AverageBeetPriceDataBoxDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets databox data with sampling frequency data for invocation context
     * @return OK
     */
    getSamplingFrequencyDataBox(signal?: AbortSignal): Promise<SampleFrequencyDataBoxDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DataBox/SamplingFrequency";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSamplingFrequencyDataBox(_response);
        });
    }

    protected processGetSamplingFrequencyDataBox(response: AxiosResponse): Promise<SampleFrequencyDataBoxDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SampleFrequencyDataBoxDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SampleFrequencyDataBoxDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getDeliveryEntitlements(signal?: AbortSignal): Promise<DeliveryEntitlementsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryEntitlement";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryEntitlements(_response);
        });
    }

    protected processGetDeliveryEntitlements(response: AxiosResponse): Promise<DeliveryEntitlementsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryEntitlementsDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryEntitlementsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the delivery plan for given Nordzucker.CropConnect.Core.Context.IInvocationContext user
     * @return OK
     */
    getMyDeliveryPlan(signal?: AbortSignal): Promise<DeliveryPlanDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlan";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyDeliveryPlan(_response);
        });
    }

    protected processGetMyDeliveryPlan(response: AxiosResponse): Promise<DeliveryPlanDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the delivery plan seetings for given role
     * @return OK
     */
    getDeliveryPlanSettings(roleDefinition: CropConnectRoleDefinitions, signal?: AbortSignal): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlanSettings/{roleDefinition}";
        if (roleDefinition === undefined || roleDefinition === null)
            throw new Error("The parameter 'roleDefinition' must be defined.");
        url_ = url_.replace("{roleDefinition}", encodeURIComponent("" + roleDefinition));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPlanSettings(_response);
        });
    }

    protected processGetDeliveryPlanSettings(response: AxiosResponse): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Updates delivery plan settings
     * @param body (optional) 
     * @return OK
     */
    updateDeliveryPlanSettings(body: UpdateDeliveryPlanSettingsRequestBody | undefined, signal?: AbortSignal): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlanSettings";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDeliveryPlanSettings(_response);
        });
    }

    protected processUpdateDeliveryPlanSettings(response: AxiosResponse): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets Nordzucker.CropConnect.Core.Authorization.CropConnectRoleDefinitions that can be used for the delivery plan settings
     * @return OK
     */
    getDeliveryPlanSettingsApplicableRoles(signal?: AbortSignal): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlanSettings/applicableRoles";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPlanSettingsApplicableRoles(_response);
        });
    }

    protected processGetDeliveryPlanSettingsApplicableRoles(response: AxiosResponse): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the info about given servicing provider (either pile coverer or loader)
     * @return OK
     */
    getDeliveryPlanProviderInfo(id: string, signal?: AbortSignal): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlan/providerInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryPlanProviderInfo(_response);
        });
    }

    protected processGetDeliveryPlanProviderInfo(response: AxiosResponse): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Sets the info for given servicing provider (either pile coverer or loader)
     * @param body (optional) 
     * @return OK
     */
    createOrUpdateServiceProviderAdditionalInfo(id: string, body: CreateOrUpdateServiceProviderAdditionalInfoRequestBody | undefined, signal?: AbortSignal): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/DeliveryPlan/deliveryPlan/providerInfo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrUpdateServiceProviderAdditionalInfo(_response);
        });
    }

    protected processCreateOrUpdateServiceProviderAdditionalInfo(response: AxiosResponse): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param forceReload (optional) 
     * @return OK
     */
    loadDocuments(forceReload: boolean | undefined, signal?: AbortSignal): Promise<DocumentSnapshotDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Documents/loadDocuments?";
        if (forceReload === null)
            throw new Error("The parameter 'forceReload' cannot be null.");
        else if (forceReload !== undefined)
            url_ += "forceReload=" + encodeURIComponent("" + forceReload) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoadDocuments(_response);
        });
    }

    protected processLoadDocuments(response: AxiosResponse): Promise<DocumentSnapshotDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentSnapshotDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentSnapshotDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Retrieves the documents for the user. Sorts by creation date descending.
     * @param folder (optional) 
     * @param top (optional) 
     * @param skip (optional) 
     * @param sortBy (optional) 
     * @param descending (optional) 
     * @return OK
     */
    getDocuments(folder: DocumentFolder | undefined, top: number | undefined, skip: number | undefined, sortBy: string | undefined, descending: boolean | undefined, signal?: AbortSignal): Promise<DocumentSnapshotDTORetrievalResultCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Documents?";
        if (folder === null)
            throw new Error("The parameter 'folder' cannot be null.");
        else if (folder !== undefined)
            url_ += "folder=" + encodeURIComponent("" + folder) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (descending === null)
            throw new Error("The parameter 'descending' cannot be null.");
        else if (descending !== undefined)
            url_ += "descending=" + encodeURIComponent("" + descending) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocuments(_response);
        });
    }

    protected processGetDocuments(response: AxiosResponse): Promise<DocumentSnapshotDTORetrievalResultCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DocumentSnapshotDTORetrievalResultCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DocumentSnapshotDTORetrievalResultCropConnectApiResponse>(null as any);
    }

    downloadDocument(documentId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Documents/download/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/pdf"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadDocument(_response);
        });
    }

    protected processDownloadDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param anonymous (optional) 
     * @param body (optional) 
     * @return Created
     */
    addFeedback(anonymous: boolean | undefined, body: AddFeedbackRequest | undefined, signal?: AbortSignal): Promise<FeedbackDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Feedback?";
        if (anonymous === null)
            throw new Error("The parameter 'anonymous' cannot be null.");
        else if (anonymous !== undefined)
            url_ += "anonymous=" + encodeURIComponent("" + anonymous) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFeedback(_response);
        });
    }

    protected processAddFeedback(response: AxiosResponse): Promise<FeedbackDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<FeedbackDtoCropConnectApiResponse>(result201);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FeedbackDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Returns the current context for the AgriPartner integration
     * @return OK
     */
    integrations_AgriPartner_GetContext(signal?: AbortSignal): Promise<AgriPartnerContextDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/agripartner/context";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_AgriPartner_GetContext(_response);
        });
    }

    protected processIntegrations_AgriPartner_GetContext(response: AxiosResponse): Promise<AgriPartnerContextDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AgriPartnerContextDtoCropConnectApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgriPartnerContextDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the info about given servicing provider (either pile coverer or loader)
     * @return OK
     */
    integrations_DeliveryPlan_GetContactDataForServiceProvider(bpNumber: string, signal?: AbortSignal): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/deliveryPlan/contactData/{bpNumber}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_DeliveryPlan_GetContactDataForServiceProvider(_response);
        });
    }

    protected processIntegrations_DeliveryPlan_GetContactDataForServiceProvider(response: AxiosResponse): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Sets the info for given servicing provider (either pile coverer or loader)
     * @param body (optional) 
     * @return OK
     */
    integrations_DeliveryPlan_CreateOrUpdateContactDataForServiceProvider(bpNumber: string, body: CreateOrUpdateServiceProviderAdditionalInfoRequestBody | undefined, signal?: AbortSignal): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/deliveryPlan/contactData/{bpNumber}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_DeliveryPlan_CreateOrUpdateContactDataForServiceProvider(_response);
        });
    }

    protected processIntegrations_DeliveryPlan_CreateOrUpdateContactDataForServiceProvider(response: AxiosResponse): Promise<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanServiceProviderDataDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the delivery plan settings for given group
     * @return OK
     */
    integrations_DeliveryPlan_GetDeliveryPlanSettings(role: CropConnectRoleDefinitions, signal?: AbortSignal): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/deliveryPlanSettings/{role}";
        if (role === undefined || role === null)
            throw new Error("The parameter 'role' must be defined.");
        url_ = url_.replace("{role}", encodeURIComponent("" + role));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_DeliveryPlan_GetDeliveryPlanSettings(_response);
        });
    }

    protected processIntegrations_DeliveryPlan_GetDeliveryPlanSettings(response: AxiosResponse): Promise<DeliveryPlanSettingsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanSettingsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the delivery plan settings for given group
     * @return OK
     */
    integrations_DeliveryPlan_GetAllDeliveryPlanSettings(signal?: AbortSignal): Promise<DeliveryPlanSettingsDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/deliveryPlanSettings";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_DeliveryPlan_GetAllDeliveryPlanSettings(_response);
        });
    }

    protected processIntegrations_DeliveryPlan_GetAllDeliveryPlanSettings(response: AxiosResponse): Promise<DeliveryPlanSettingsDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<DeliveryPlanSettingsDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryPlanSettingsDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Returns the currently selected business partner number for given context
     * @return OK
     */
    integrations_Eshop_GetSelectedBusinessPartnerNumber(signal?: AbortSignal): Promise<StringCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Integrations/eshop/businesspartner";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIntegrations_Eshop_GetSelectedBusinessPartnerNumber(_response);
        });
    }

    protected processIntegrations_Eshop_GetSelectedBusinessPartnerNumber(response: AxiosResponse): Promise<StringCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<StringCropConnectApiResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StringCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    location(body: AddMonitoringLocationParameters | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/location";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocation(_response);
        });
    }

    protected processLocation(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BooleanCropConnectApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    campaignYear(campaignYear: string, signal?: AbortSignal): Promise<MonitoringLocationDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/locations/campaignYear/{campaignYear}";
        if (campaignYear === undefined || campaignYear === null)
            throw new Error("The parameter 'campaignYear' must be defined.");
        url_ = url_.replace("{campaignYear}", encodeURIComponent("" + campaignYear));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCampaignYear(_response);
        });
    }

    protected processCampaignYear(response: AxiosResponse): Promise<MonitoringLocationDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringLocationDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringLocationDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    personPOST(body: AddMonitoringPersonParameters | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/person";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonPOST(_response);
        });
    }

    protected processPersonPOST(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BooleanCropConnectApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    personPUT(body: UpdateMonitoringPersonParameters | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/person";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonPUT(_response);
        });
    }

    protected processPersonPUT(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BooleanCropConnectApiResponse>(result201);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    campaignYear2(campaignYear: string, signal?: AbortSignal): Promise<MonitoringPersonDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/persons/campaignYear/{campaignYear}";
        if (campaignYear === undefined || campaignYear === null)
            throw new Error("The parameter 'campaignYear' must be defined.");
        url_ = url_.replace("{campaignYear}", encodeURIComponent("" + campaignYear));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCampaignYear2(_response);
        });
    }

    protected processCampaignYear2(response: AxiosResponse): Promise<MonitoringPersonDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringPersonDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringPersonDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    personGET(bpNumber: string, signal?: AbortSignal): Promise<MonitoringPersonDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/person/{bpNumber}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPersonGET(_response);
        });
    }

    protected processPersonGET(response: AxiosResponse): Promise<MonitoringPersonDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringPersonDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringPersonDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    diseasesresult(body: AddMonitoringResultDiseasesParameters | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/diseasesresult";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiseasesresult(_response);
        });
    }

    protected processDiseasesresult(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BooleanCropConnectApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    insectsresult(body: AddMonitoringResultInsectsParameters | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/insectsresult";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsectsresult(_response);
        });
    }

    protected processInsectsresult(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<BooleanCropConnectApiResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = JSON.parse(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    insectmeta(signal?: AbortSignal): Promise<MonitoringInsectMetaDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/insectmeta";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsectmeta(_response);
        });
    }

    protected processInsectmeta(response: AxiosResponse): Promise<MonitoringInsectMetaDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringInsectMetaDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringInsectMetaDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    diseasemeta(signal?: AbortSignal): Promise<MonitoringDiseaseMetaDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/diseasemeta";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDiseasemeta(_response);
        });
    }

    protected processDiseasemeta(response: AxiosResponse): Promise<MonitoringDiseaseMetaDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringDiseaseMetaDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringDiseaseMetaDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    calendarWeek(calendarWeek: number, signal?: AbortSignal): Promise<MonitoringResultsInsectsListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/insectresults/calendarWeek/{calendarWeek}";
        if (calendarWeek === undefined || calendarWeek === null)
            throw new Error("The parameter 'calendarWeek' must be defined.");
        url_ = url_.replace("{calendarWeek}", encodeURIComponent("" + calendarWeek));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalendarWeek(_response);
        });
    }

    protected processCalendarWeek(response: AxiosResponse): Promise<MonitoringResultsInsectsListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringResultsInsectsListDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringResultsInsectsListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    calendarWeek2(calendarWeek: number, signal?: AbortSignal): Promise<MonitoringResultsDiseasesListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/diseaseresults/calendarWeek/{calendarWeek}";
        if (calendarWeek === undefined || calendarWeek === null)
            throw new Error("The parameter 'calendarWeek' must be defined.");
        url_ = url_.replace("{calendarWeek}", encodeURIComponent("" + calendarWeek));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalendarWeek2(_response);
        });
    }

    protected processCalendarWeek2(response: AxiosResponse): Promise<MonitoringResultsDiseasesListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringResultsDiseasesListDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringResultsDiseasesListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    campaignYear3(campaignYear: string, signal?: AbortSignal): Promise<MonitoringResultsInsectsListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/insectresults/campaignYear/{campaignYear}";
        if (campaignYear === undefined || campaignYear === null)
            throw new Error("The parameter 'campaignYear' must be defined.");
        url_ = url_.replace("{campaignYear}", encodeURIComponent("" + campaignYear));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCampaignYear3(_response);
        });
    }

    protected processCampaignYear3(response: AxiosResponse): Promise<MonitoringResultsInsectsListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringResultsInsectsListDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringResultsInsectsListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    campaignYear4(campaignYear: string, signal?: AbortSignal): Promise<MonitoringResultsDiseasesListDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Monitoring/diseaseresults/campaignYear/{campaignYear}";
        if (campaignYear === undefined || campaignYear === null)
            throw new Error("The parameter 'campaignYear' must be defined.");
        url_ = url_.replace("{campaignYear}", encodeURIComponent("" + campaignYear));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCampaignYear4(_response);
        });
    }

    protected processCampaignYear4(response: AxiosResponse): Promise<MonitoringResultsDiseasesListDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MonitoringResultsDiseasesListDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MonitoringResultsDiseasesListDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportFinancesEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/finances";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportFinancesEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportFinancesEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportSingleBeetEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/singleBeetDelivery";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportSingleBeetEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportSingleBeetEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportProductsEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/products";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportProductsEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportProductsEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportBenchmarkEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/benchmark";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportBenchmarkEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportBenchmarkEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportContractVolumesEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/contractvolumes";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportContractVolumesEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportContractVolumesEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getPowerBiReportContractFulfillmentEmbedToken(signal?: AbortSignal): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/PowerBiReporting/embedToken/contractfulfillment";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPowerBiReportContractFulfillmentEmbedToken(_response);
        });
    }

    protected processGetPowerBiReportContractFulfillmentEmbedToken(response: AxiosResponse): Promise<PowerBiEmbedTokenDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PowerBiEmbedTokenDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the role assignments for given user (does not include the ones that might be included via access on behalf).
    Do not use this method for the security trimming!
     * @return OK
     */
    getMyRoles(signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/me";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMyRoles(_response);
        });
    }

    protected processGetMyRoles(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Use this endpoint in order to get the effective permissions for the invoking user. Effective permissions include
    also the ones that are applied to the user due to accessing on behalf. This is the method that should be used for
    security trimming in frontend.
     * @return OK
     */
    getEffectiveRoles(signal?: AbortSignal): Promise<EffectiveRoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/effective";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEffectiveRoles(_response);
        });
    }

    protected processGetEffectiveRoles(response: AxiosResponse): Promise<EffectiveRoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<EffectiveRoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EffectiveRoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUserRoles(userId: string, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserRoles(_response);
        });
    }

    protected processGetUserRoles(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addBusinessPartnerRoleAssignment(bpNumber: string, userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/businessPartner/{userId}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBusinessPartnerRoleAssignment(_response);
        });
    }

    protected processAddBusinessPartnerRoleAssignment(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    removeRoleAssignmentForBusinessPartner(bpNumber: string, userId: string, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/businessPartner/{userId}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRoleAssignmentForBusinessPartner(_response);
        });
    }

    protected processRemoveRoleAssignmentForBusinessPartner(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addGlobalRoleAssignment(userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/global/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddGlobalRoleAssignment(_response);
        });
    }

    protected processAddGlobalRoleAssignment(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    removeGlobalRoleAssignment(userId: string, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/global/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveGlobalRoleAssignment(_response);
        });
    }

    protected processRemoveGlobalRoleAssignment(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRolesToBusinessPartnerRoleAssignments(bpNumber: string, userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/roles/businessPartner/{userId}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRolesToBusinessPartnerRoleAssignments(_response);
        });
    }

    protected processAddRolesToBusinessPartnerRoleAssignments(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeRolesFromBusinessPartnerRoleAssignments(bpNumber: string, userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/roles/businessPartner/{userId}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRolesFromBusinessPartnerRoleAssignments(_response);
        });
    }

    protected processRemoveRolesFromBusinessPartnerRoleAssignments(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addRolesToGlobalRoleAssignments(userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/roles/global/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRolesToGlobalRoleAssignments(_response);
        });
    }

    protected processAddRolesToGlobalRoleAssignments(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    removeRolesFromGlobalRoleAssignments(bpNumber: string, userId: string, body: CropConnectRoleDefinitions[] | undefined, signal?: AbortSignal): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/RoleAssignments/roles/global/{userId}";
        if (bpNumber === undefined || bpNumber === null)
            throw new Error("The parameter 'bpNumber' must be defined.");
        url_ = url_.replace("{bpNumber}", encodeURIComponent("" + bpNumber));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRolesFromGlobalRoleAssignments(_response);
        });
    }

    protected processRemoveRolesFromGlobalRoleAssignments(response: AxiosResponse): Promise<RoleAssignmentsDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleAssignmentsDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets survey with given Nordzucker.CropConnect.Core.Models.AccessId
     * @return OK
     */
    getSurvey(surveyId: string, signal?: AbortSignal): Promise<SurveyDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurvey(_response);
        });
    }

    protected processGetSurvey(response: AxiosResponse): Promise<SurveyDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Updates survey
     * @param body (optional) 
     * @return OK
     */
    updateSurvey(surveyId: string, body: AddOrUpdateSurveyRequest | undefined, signal?: AbortSignal): Promise<SurveyDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSurvey(_response);
        });
    }

    protected processUpdateSurvey(response: AxiosResponse): Promise<SurveyDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Deletes survey among with all related questions
     * @return OK
     */
    deleteSurvey(surveyId: string, signal?: AbortSignal): Promise<SurveyDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurvey(_response);
        });
    }

    protected processDeleteSurvey(response: AxiosResponse): Promise<SurveyDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Lists the surveys of given type
     * @param top (optional) 
     * @param skip (optional) 
     * @return OK
     */
    getSurveyByType(surveyType: SurveyType, top: number | undefined, skip: number | undefined, signal?: AbortSignal): Promise<SurveyDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/byType/{surveyType}?";
        if (surveyType === undefined || surveyType === null)
            throw new Error("The parameter 'surveyType' must be defined.");
        url_ = url_.replace("{surveyType}", encodeURIComponent("" + surveyType));
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyByType(_response);
        });
    }

    protected processGetSurveyByType(response: AxiosResponse): Promise<SurveyDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Adds survey
     * @param body (optional) 
     * @return OK
     */
    addSurvey(body: AddOrUpdateSurveyRequest | undefined, signal?: AbortSignal): Promise<SurveyDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSurvey(_response);
        });
    }

    protected processAddSurvey(response: AxiosResponse): Promise<SurveyDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Adds survey question
     * @param body (optional) 
     * @return OK
     */
    addSurveyQuestion(surveyId: string, body: AddSurveyQuestionRequest | undefined, signal?: AbortSignal): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}/Questions";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSurveyQuestion(_response);
        });
    }

    protected processAddSurveyQuestion(response: AxiosResponse): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Updates survey question
     * @param body (optional) 
     * @return OK
     */
    updateSurveyQuestion(surveyId: string, questionId: string, body: UpdateSurveyQuestionRequest | undefined, signal?: AbortSignal): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}/Questions/{questionId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSurveyQuestion(_response);
        });
    }

    protected processUpdateSurveyQuestion(response: AxiosResponse): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Deletes survey question
     * @return OK
     */
    deleteSurveyQuestion(surveyId: string, questionId: string, signal?: AbortSignal): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}/Questions/{questionId}";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSurveyQuestion(_response);
        });
    }

    protected processDeleteSurveyQuestion(response: AxiosResponse): Promise<SurveyQuestionDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyQuestionDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the survey form
     * @return OK
     */
    getSurveyFormForSurvey(surveyId: string, signal?: AbortSignal): Promise<SurveyFormDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}/form";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSurveyFormForSurvey(_response);
        });
    }

    protected processGetSurveyFormForSurvey(response: AxiosResponse): Promise<SurveyFormDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyFormDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyFormDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for answering the survey form
     * @param body (optional) 
     * @return OK
     */
    answerSurveyForm(surveyId: string, body: AnswerSurveyRequest | undefined, signal?: AbortSignal): Promise<SurveyFormDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/{surveyId}/form";
        if (surveyId === undefined || surveyId === null)
            throw new Error("The parameter 'surveyId' must be defined.");
        url_ = url_.replace("{surveyId}", encodeURIComponent("" + surveyId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAnswerSurveyForm(_response);
        });
    }

    protected processAnswerSurveyForm(response: AxiosResponse): Promise<SurveyFormDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<SurveyFormDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyFormDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param code (optional) 
     * @return OK
     */
    clearCache(code: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/System/clearcache?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Gets all tasks
     * @return OK
     */
    all(signal?: AbortSignal): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks/all";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAll(_response);
        });
    }

    protected processAll(response: AxiosResponse): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Gets tasks for given user
     * @return OK
     */
    getTasks(signal?: AbortSignal): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasks(_response);
        });
    }

    protected processGetTasks(response: AxiosResponse): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Adds a task
     * @param body (optional) 
     * @return OK
     */
    addTask(body: AddOrUpdateTaskRequest | undefined, signal?: AbortSignal): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddTask(_response);
        });
    }

    protected processAddTask(response: AxiosResponse): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Gets tasks for given country
     * @return OK
     */
    getTasksForCountry(country: CropConnectCountry, signal?: AbortSignal): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks/{country}";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTasksForCountry(_response);
        });
    }

    protected processGetTasksForCountry(response: AxiosResponse): Promise<CropConnectTaskDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Updates a task
     * @param body (optional) 
     * @return OK
     */
    updateTask(taskId: string, body: AddOrUpdateTaskRequest | undefined, signal?: AbortSignal): Promise<CropConnectTaskDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTask(_response);
        });
    }

    protected processUpdateTask(response: AxiosResponse): Promise<CropConnectTaskDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Deletes a task
     * @return OK
     */
    deleteTask(taskId: string, signal?: AbortSignal): Promise<CropConnectTaskDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTask(_response);
        });
    }

    protected processDeleteTask(response: AxiosResponse): Promise<CropConnectTaskDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectTaskDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectTaskDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for downloading the general document assigned to task
     */
    downloadGeneralDocumentForTask(documentId: number, taskId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Tasks/generaldocument/{taskId}/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadGeneralDocumentForTask(_response);
        });
    }

    protected processDownloadGeneralDocumentForTask(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Gets Nordzucker.CropConnect.Core.Authorization.CropConnectRoleDefinitions that can be used for my tasks
     * @return OK
     */
    applicableRoles(signal?: AbortSignal): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Tasks/applicableRoles";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApplicableRoles(_response);
        });
    }

    protected processApplicableRoles(response: AxiosResponse): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTranslationsByLanguage(language: CropConnectLanguages, signal?: AbortSignal): Promise<TranslationDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslationsByLanguage(_response);
        });
    }

    protected processGetTranslationsByLanguage(response: AxiosResponse): Promise<TranslationDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TranslationDtoCropConnectApiResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getTranslationsByUserLanguage(signal?: AbortSignal): Promise<TranslationDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslationsByUserLanguage(_response);
        });
    }

    protected processGetTranslationsByUserLanguage(response: AxiosResponse): Promise<TranslationDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TranslationDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return Created
     */
    updateTranslationKeys(code: string | undefined, body: any | undefined, signal?: AbortSignal): Promise<TranslationDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation/keys/update?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTranslationKeys(_response);
        });
    }

    protected processUpdateTranslationKeys(response: AxiosResponse): Promise<TranslationDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<TranslationDtoCropConnectApiResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return Created
     */
    updateTranslationKeysByLanguage(language: CropConnectLanguages, code: string | undefined, body: any | undefined, signal?: AbortSignal): Promise<TranslationDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation/keys/update/{language}?";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTranslationKeysByLanguage(_response);
        });
    }

    protected processUpdateTranslationKeysByLanguage(response: AxiosResponse): Promise<TranslationDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<TranslationDtoCropConnectApiResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    updateTranslationValue(body: UpdateTranslationValueParameters | undefined, signal?: AbortSignal): Promise<TranslationDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation/value/update";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTranslationValue(_response);
        });
    }

    protected processUpdateTranslationValue(response: AxiosResponse): Promise<TranslationDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JSON.parse(resultData201);
            return Promise.resolve<TranslationDtoCropConnectApiResponse>(result201);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getAllTranslations(signal?: AbortSignal): Promise<TranslationDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Translation/all";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTranslations(_response);
        });
    }

    protected processGetAllTranslations(response: AxiosResponse): Promise<TranslationDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TranslationDtoListCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getUserById(id: string, signal?: AbortSignal): Promise<CropConnectUserDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/User/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: AxiosResponse): Promise<CropConnectUserDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    getLoggedInUser(signal?: AbortSignal): Promise<CropConnectUserDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/User/me";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoggedInUser(_response);
        });
    }

    protected processGetLoggedInUser(response: AxiosResponse): Promise<CropConnectUserDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @return OK
     */
    initialLogin(signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/User/InitialLogin";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitialLogin(_response);
        });
    }

    protected processInitialLogin(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BooleanCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeMyLanguage(body: CropConnectLanguages | undefined, signal?: AbortSignal): Promise<CropConnectLanguagesCropConnectApiResponse> {
        let url_ = this.baseUrl + "/User/ChangeMyLanguage";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeMyLanguage(_response);
        });
    }

    protected processChangeMyLanguage(response: AxiosResponse): Promise<CropConnectLanguagesCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectLanguagesCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectLanguagesCropConnectApiResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    changeMyDisplayName(body: string | undefined, signal?: AbortSignal): Promise<CropConnectUserDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/User/ChangeMyDisplayName";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeMyDisplayName(_response);
        });
    }

    protected processChangeMyDisplayName(response: AxiosResponse): Promise<CropConnectUserDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectUserDtoCropConnectApiResponse>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    createBusinessPartnerOnboardingStatistics(file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserStatisticsGeneration/CreateBusinessPartnerOnboardingStatistics";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateBusinessPartnerOnboardingStatistics(_response);
        });
    }

    protected processCreateBusinessPartnerOnboardingStatistics(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    createUserOnboardingStatistics(file: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/UserStatisticsGeneration/CreateUserOnboardingStatistics";
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUserOnboardingStatistics(_response);
        });
    }

    protected processCreateUserOnboardingStatistics(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    getWeatherById(signal?: AbortSignal): Promise<WeatherDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Weather";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeatherById(_response);
        });
    }

    protected processGetWeatherById(response: AxiosResponse): Promise<WeatherDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WeatherDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WeatherDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Gets the Nordzucker.CropConnect.Core.DTOs.WidgetDto for given parent
     * @return OK
     */
    getWidgetsForParent(parent: string, signal?: AbortSignal): Promise<WidgetDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/widgets/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWidgetsForParent(_response);
        });
    }

    protected processGetWidgetsForParent(response: AxiosResponse): Promise<WidgetDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WidgetDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Request for adding widget to given parent
     * @param body (optional) 
     * @return OK
     */
    addWidget(parent: string, body: AddWidgetRequest | undefined, signal?: AbortSignal): Promise<WidgetDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/widgets/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddWidget(_response);
        });
    }

    protected processAddWidget(response: AxiosResponse): Promise<WidgetDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WidgetDtoCropConnectApiResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for updating the given widget
     * @param body (optional) 
     * @return OK
     */
    updateWidget(parent: string, widgetId: string, body: UpdateWidgetRequest | undefined, signal?: AbortSignal): Promise<WidgetDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/widgets/{parent}/{widgetId}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWidget(_response);
        });
    }

    protected processUpdateWidget(response: AxiosResponse): Promise<WidgetDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<WidgetDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WidgetDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for deleting given widget
     * @param body (optional) 
     * @return OK
     */
    deleteWidget(parent: string, widgetId: string, body: AddWidgetRequest | undefined, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/widgets/{parent}/{widgetId}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        if (widgetId === undefined || widgetId === null)
            throw new Error("The parameter 'widgetId' must be defined.");
        url_ = url_.replace("{widgetId}", encodeURIComponent("" + widgetId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteWidget(_response);
        });
    }

    protected processDeleteWidget(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BooleanCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * Used for getting the Nordzucker.CropConnect.Core.Authorization.CropConnectRoleDefinitions that are applicable to general documents
     * @return OK
     */
    getGeneralDocumentsApplicableRoles(signal?: AbortSignal): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/generalDocuments/applicableRoles";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralDocumentsApplicableRoles(_response);
        });
    }

    protected processGetGeneralDocumentsApplicableRoles(response: AxiosResponse): Promise<CropConnectRoleDefinitionsListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CropConnectRoleDefinitionsListCropConnectApiResponse>(null as any);
    }

    /**
     * Used for getting the general documents for given widget
     * @return OK
     */
    getGeneralDocuments(parentId: string, signal?: AbortSignal): Promise<GeneralDocumentLightDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/generalDocuments";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralDocuments(_response);
        });
    }

    protected processGetGeneralDocuments(response: AxiosResponse): Promise<GeneralDocumentLightDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentLightDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentLightDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Used for adding the general document
     * @param body (optional) 
     * @return OK
     */
    addGeneralDocument(parentId: string, body: AddGeneralDocumentRequest | undefined, signal?: AbortSignal): Promise<GeneralDocumentLightDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/generalDocuments";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddGeneralDocument(_response);
        });
    }

    protected processAddGeneralDocument(response: AxiosResponse): Promise<GeneralDocumentLightDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentLightDtoCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentLightDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for getting all general documents
     * @return OK
     */
    getAllGeneralDocumentsForParent(parentId: string, signal?: AbortSignal): Promise<GeneralDocumentDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/allGeneralDocuments";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllGeneralDocumentsForParent(_response);
        });
    }

    protected processGetAllGeneralDocumentsForParent(response: AxiosResponse): Promise<GeneralDocumentDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Used for getting all general documents
     * @return OK
     */
    listAllGeneralDocuments(signal?: AbortSignal): Promise<GeneralDocumentDtoListCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/listAllGeneralDocuments";
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllGeneralDocuments(_response);
        });
    }

    protected processListAllGeneralDocuments(response: AxiosResponse): Promise<GeneralDocumentDtoListCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentDtoListCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentDtoListCropConnectApiResponse>(null as any);
    }

    /**
     * Used for updating the general document
     * @param body (optional) 
     * @return OK
     */
    updateGeneralDocument(parentId: string, documentId: string, body: UpdateGeneralDocumentRequest | undefined, signal?: AbortSignal): Promise<GeneralDocumentLightDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/generalDocuments/{documentId}";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
    
        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,

            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateGeneralDocument(_response);
        });
    }

    protected processUpdateGeneralDocument(response: AxiosResponse): Promise<GeneralDocumentLightDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentLightDtoCropConnectApiResponse>(result200);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = JSON.parse(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentLightDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for deleting the general document
     * @return OK
     */
    deleteGeneralDocument(parentId: string, documentId: string, signal?: AbortSignal): Promise<BooleanCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/generalDocuments/{documentId}";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGeneralDocument(_response);
        });
    }

    protected processDeleteGeneralDocument(response: AxiosResponse): Promise<BooleanCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<BooleanCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BooleanCropConnectApiResponse>(null as any);
    }

    /**
     * Used for downloading the general document
     */
    downloadGeneralDocument(parentId: string, documentId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/{parentId}/generalDocuments/{documentId}";
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadGeneralDocument(_response);
        });
    }

    protected processDownloadGeneralDocument(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Used for getting the general documents folder
     * @param folderId (optional) Must check "Send empty value" or Swagger passes a comma for empty values otherwise
     * @return OK
     */
    getGeneralDocumentsFolder(folderId: number | null | undefined, signal?: AbortSignal): Promise<GeneralDocumentFolderDtoCropConnectApiResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/generalDocuments/folders/{folderId}";
        if (folderId !== null && folderId !== undefined)
        url_ = url_.replace("{folderId}", encodeURIComponent("" + folderId));
        else
            url_ = url_.replace("/{folderId}", "");
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            signal
        };
        return this.transformOptions(options_, true).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralDocumentsFolder(_response);
        });
    }

    protected processGetGeneralDocumentsFolder(response: AxiosResponse): Promise<GeneralDocumentFolderDtoCropConnectApiResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<GeneralDocumentFolderDtoCropConnectApiResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = JSON.parse(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralDocumentFolderDtoCropConnectApiResponse>(null as any);
    }

    /**
     * Used for downloading the general document
     */
    downloadGeneralDocumentById(documentId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Widgets/widgets/generalDocuments/{documentId}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");
    
        let options_: AxiosRequestConfig = {

            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };
        return this.transformOptions(options_, false).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadGeneralDocumentById(_response);
        });
    }

    protected processDownloadGeneralDocumentById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface AccessibleBusinessPartnerRangeDto {
    low?: number;
    high?: number;
}

export interface AccessibleBusinessPartnerRangeDtoArrayCropConnectApiResponse {
    data?: AccessibleBusinessPartnerRangeDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface AddFeedbackRequest {
    body?: string | undefined;
}

/** Used for adding or updating the general document */
export interface AddGeneralDocumentRequest {
    /** Bp numbers or roles for whom the document should be visible. Should be formatted as Json array of strings */
    visibleFor: string[] | undefined;
    /** Properties of the document. Should be formatted as JSON object */
    properties?: { [key: string]: any; } | undefined;
    /** The parent headline or subheadline */
    parentHeadline?: string | undefined;
    /** The id of the parent folder */
    parentFolderId: number;
    /** The document id */
    documentId: number;
}

export interface AddMonitoringLocationParameters {
    campaignYear?: string | undefined;
    name?: string | undefined;
    country?: CropConnectCountry;
    beetVariety?: string | undefined;
    factory?: string | undefined;
    note?: string | undefined;
    longitude?: number;
    latitude?: number;
}

export interface AddMonitoringPersonParameters {
    campaignYear?: string | undefined;
    bpNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    note?: string | undefined;
    countries?: CropConnectCountry[] | undefined;
    doesLocationManagement?: boolean;
    doesDiseaseMonitoring?: boolean;
    doesInsectMonitoring?: boolean;
}

export interface AddMonitoringResultDiseasesParameters {
    date?: string;
    locationId?: string | undefined;
    lastTreatmentDate?: string | undefined;
    numberOfTreatments?: number;
    diseasePercentages?: { [key: string]: number; } | undefined;
}

export interface AddMonitoringResultInsectsParameters {
    date?: string;
    plantStageId?: number;
    locationId?: string | undefined;
    lastTreatmentDate?: string | undefined;
    numberOfTreatments?: number;
    insectData?: { [key: string]: number; } | undefined;
}

export interface AddNewConsultantAgricenterParameters {
    agricenters?: AgricenterToAdd[] | undefined;
}

export interface AddOrUpdateConsultantParameters {
    agricenterId: string;
    sapUserId?: string | undefined;
    displayName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    title?: string | undefined;
    image?: string | undefined;
}

/** Request model for updating the survey */
export interface AddOrUpdateSurveyRequest {
    /** Name of the survey */
    name: string | undefined;
    /** Headline of the survey */
    headline?: string | undefined;
    type: SurveyType;
    /** Start date of the survey */
    startDate?: string | undefined;
    /** End date of the survey */
    endDate?: string | undefined;
    /** Additional data */
    additionalProperties?: { [key: string]: any; } | undefined;
}

/** Request model for updating the survey */
export interface AddOrUpdateTaskRequest {
    type: TaskType;
    /** Start date of the task */
    startDate?: string;
    /** End date of the task */
    endDate?: string;
    /** The business partners to which the tasks will be assigned */
    assignedToBusinessPartners?: string[] | undefined;
    /** Nordzucker.CropConnect.Core.Authorization.CropConnectRoleDefinitions roles for which the tasks has been assigned */
    assignedToRoles?: CropConnectRoleDefinitions[] | undefined;
    /** Nordzucker.CropConnect.Core.Enums.CropConnectCountry countries for which the tasks has been assigned */
    readonly assignedToCountries?: CropConnectCountry[] | undefined;
    /** Property bag for the task */
    propertyBag?: { [key: string]: any; } | undefined;
}

/** Request body for adding survey question */
export interface AddSurveyQuestionRequest {
    /** Properties of the question. */
    properties?: { [key: string]: any; } | undefined;
    /** Question order */
    order?: number;
}

/** Body of the request used for adding the widgets */
export interface AddWidgetRequest {
    widgetType: WidgetType;
    /** Order of the widgets */
    order: number;
    /** Property bag */
    propertyBag?: { [key: string]: any; } | undefined;
}

export interface AgriPartnerContextDto {
    businessPartnerNumber?: string | undefined;
    internalUserId?: string | undefined;
    isAccessOnBehalfActive?: boolean | undefined;
}

export interface AgriPartnerContextDtoCropConnectApiResponse {
    data?: AgriPartnerContextDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface AgricenterDTO {
    id?: string | undefined;
}

export interface AgricenterToAdd {
    id?: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
}

export interface AgricenterWithConsultantListDto {
    id: string | undefined;
    name?: string | undefined;
    shortName?: string | undefined;
    consultants?: ConsultantDTO[] | undefined;
}

export interface AgricenterWithConsultantListDtoCropConnectApiResponse {
    data?: AgricenterWithConsultantListDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface AgricentersDto {
    factories?: AgricenterDTO[] | undefined;
}

export interface AgricentersDtoCropConnectApiResponse {
    data?: AgricentersDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface AnalyticsContextDtoCropConnectApiResponse {
    data?: { [key: string]: string; } | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

/** Request for answering the survey */
export interface AnswerSurveyRequest {
    /** Answers */
    answers: { [key: string]: any; } | undefined;
    /** Additional data */
    additionalData?: { [key: string]: any; } | undefined;
}

export interface AverageBeetPriceDataBoxDto {
    accessId?: string | undefined;
    averagePrices: AveragePriceRecord[] | undefined;
}

export interface AverageBeetPriceDataBoxDtoCropConnectApiResponse {
    data?: AverageBeetPriceDataBoxDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface AveragePriceRecord {
    year?: number | undefined;
    price?: number | undefined;
}

export interface BooleanCropConnectApiResponse {
    data?: boolean;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface BusinessPartnerDto {
    accessId: string | undefined;
    businessPartnerNumber?: string | undefined;
    displayName?: string | undefined;
    countryCode?: string | undefined;
    streetName?: string | undefined;
    houseNumber?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    district?: string | undefined;
    agriCenterName?: string | undefined;
    bpTypes?: string[] | undefined;
    agriCenterNumber?: string | undefined;
    factoryNumber?: string | undefined;
    activated?: boolean;
}

export interface BusinessPartnerDtoCropConnectApiResponse {
    data?: BusinessPartnerDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface BusinessPartnerMasterdataDtoCropConnectApiResponse {
    data?: { [key: string]: any; } | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface ConsultantDTO {
    displayName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    description?: string | undefined;
    sapUserId?: string | undefined;
    image?: string | undefined;
}

export interface ContextDto {
    userDisplayName?: string | undefined;
    activeBpNumber?: string | undefined;
    activeBpNumberCountry?: string | undefined;
    selectedLanguage?: CropConnectLanguages;
    analyticsContext?: { [key: string]: string; } | undefined;
    nordzuckerInternalUserId?: string | undefined;
    isAccessOnBehalfActive?: boolean | undefined;
    accessibleBusinessPartnerRanges?: AccessibleBusinessPartnerRangeDto[] | undefined;
    isInitialLogin?: boolean | undefined;
    globalRoleAssignment?: RoleAssignmentDto;
    businessPartnerRoleAssignment?: RoleAssignmentDto;
    businessPartners?: SelectableBusinessPartnerDto[] | undefined;
    enabledFeatures?: string[] | undefined;
}

export interface ContextDtoCropConnectApiResponse {
    data?: ContextDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

/** Body of the request to create or update service provider additional info */
export interface CreateOrUpdateServiceProviderAdditionalInfoRequestBody {
    /** Additional data provided */
    additionalData?: string | undefined;
}

export enum CropConnectCountry {
    None = "None",
    DE = "DE",
    DK = "DK",
    SE = "SE",
    PL = "PL",
    LT = "LT",
    SK = "SK",
    FI = "FI",
    LV = "LV",
}

export enum CropConnectLanguages {
    None = "None",
    DaDA = "DaDA",
    DeDE = "DeDE",
    EnGB = "EnGB",
    FiFI = "FiFI",
    LtLT = "LtLT",
    PlPL = "PlPL",
    SkSK = "SkSK",
    SvSE = "SvSE",
}

export interface CropConnectLanguagesCropConnectApiResponse {
    data?: CropConnectLanguages;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export enum CropConnectRoleDefinitions {
    None = "None",
    Grower_Beet = "Grower_Beet",
    BusinessPartnerOwner = "BusinessPartnerOwner",
    DocumentsReader = "DocumentsReader",
    DocumentsContributor = "DocumentsContributor",
    DocumentsAdmin = "DocumentsAdmin",
    RedCertAdmin = "RedCertAdmin",
    DocumentPublisher = "DocumentPublisher",
    TaskCreator = "TaskCreator",
    GlobalAdmin = "GlobalAdmin",
    Grower = "Grower",
    Grower_Beet_DE = "Grower_Beet_DE",
    Grower_Beet_DK = "Grower_Beet_DK",
    Grower_Beet_FI = "Grower_Beet_FI",
    Grower_Beet_LT = "Grower_Beet_LT",
    Grower_Beet_PL = "Grower_Beet_PL",
    Grower_Beet_SE = "Grower_Beet_SE",
    Grower_Beet_SK = "Grower_Beet_SK",
    Grower_Beet_Organic_DE = "Grower_Beet_Organic_DE",
    Grower_Beet_Organic_DK = "Grower_Beet_Organic_DK",
    Grower_Beet_Organic_FI = "Grower_Beet_Organic_FI",
    Grower_Beet_Organic_LT = "Grower_Beet_Organic_LT",
    Grower_Beet_Organic_PL = "Grower_Beet_Organic_PL",
    Grower_Beet_Organic_SE = "Grower_Beet_Organic_SE",
    Grower_Beet_Organic_SK = "Grower_Beet_Organic_SK",
    Grower_DE = "Grower_DE",
    Grower_DK = "Grower_DK",
    Grower_FI = "Grower_FI",
    Grower_LT = "Grower_LT",
    Grower_PL = "Grower_PL",
    Grower_SE = "Grower_SE",
    Grower_SK = "Grower_SK",
    Grower_Organic = "Grower_Organic",
    Grower_Organic_DE = "Grower_Organic_DE",
    Grower_Organic_DK = "Grower_Organic_DK",
    Grower_Organic_FI = "Grower_Organic_FI",
    Grower_Organic_LT = "Grower_Organic_LT",
    Grower_Organic_PL = "Grower_Organic_PL",
    Grower_Organic_SE = "Grower_Organic_SE",
    Grower_Organic_SK = "Grower_Organic_SK",
    Grower_Organic_Beet = "Grower_Organic_Beet",
    Grower_Organic_Pea = "Grower_Organic_Pea",
    Grower_Organic_Cane = "Grower_Organic_Cane",
    Grower_Pea_DE = "Grower_Pea_DE",
    Grower_Pea_DK = "Grower_Pea_DK",
    Grower_Pea_FI = "Grower_Pea_FI",
    Grower_Pea_LT = "Grower_Pea_LT",
    Grower_Pea_PL = "Grower_Pea_PL",
    Grower_Pea_SE = "Grower_Pea_SE",
    Grower_Pea_SK = "Grower_Pea_SK",
    Grower_Pea_Organic_DE = "Grower_Pea_Organic_DE",
    Grower_Pea_Organic_DK = "Grower_Pea_Organic_DK",
    Grower_Pea_Organic_FI = "Grower_Pea_Organic_FI",
    Grower_Pea_Organic_LT = "Grower_Pea_Organic_LT",
    Grower_Pea_Organic_PL = "Grower_Pea_Organic_PL",
    Grower_Pea_Organic_SE = "Grower_Pea_Organic_SE",
    Grower_Pea_Organic_SK = "Grower_Pea_Organic_SK",
    Grower_SugarCane_DE = "Grower_SugarCane_DE",
    Grower_SugarCane_DK = "Grower_SugarCane_DK",
    Grower_SugarCane_FI = "Grower_SugarCane_FI",
    Grower_SugarCane_LT = "Grower_SugarCane_LT",
    Grower_SugarCane_PL = "Grower_SugarCane_PL",
    Grower_SugarCane_SE = "Grower_SugarCane_SE",
    Grower_SugarCane_SK = "Grower_SugarCane_SK",
    Grower_SugarCane_Organic_DE = "Grower_SugarCane_Organic_DE",
    Grower_SugarCane_Organic_DK = "Grower_SugarCane_Organic_DK",
    Grower_SugarCane_Organic_FI = "Grower_SugarCane_Organic_FI",
    Grower_SugarCane_Organic_LT = "Grower_SugarCane_Organic_LT",
    Grower_SugarCane_Organic_PL = "Grower_SugarCane_Organic_PL",
    Grower_SugarCane_Organic_SE = "Grower_SugarCane_Organic_SE",
    Grower_SugarCane_Organic_SK = "Grower_SugarCane_Organic_SK",
    MonitoringAdmin = "MonitoringAdmin",
    Grower_Pea = "Grower_Pea",
    ReportReader = "ReportReader",
    ServiceProvider = "ServiceProvider",
    ServiceProvider_Cleaner_DE = "ServiceProvider_Cleaner_DE",
    ServiceProvider_Cleaner_DK = "ServiceProvider_Cleaner_DK",
    ServiceProvider_Cleaner_FI = "ServiceProvider_Cleaner_FI",
    ServiceProvider_Cleaner_LT = "ServiceProvider_Cleaner_LT",
    ServiceProvider_Cleaner_PL = "ServiceProvider_Cleaner_PL",
    ServiceProvider_Cleaner_SE = "ServiceProvider_Cleaner_SE",
    ServiceProvider_Cleaner_SK = "ServiceProvider_Cleaner_SK",
    ServiceProvider_Coverer_DE = "ServiceProvider_Coverer_DE",
    ServiceProvider_Coverer_DK = "ServiceProvider_Coverer_DK",
    ServiceProvider_Coverer_FI = "ServiceProvider_Coverer_FI",
    ServiceProvider_Coverer_LT = "ServiceProvider_Coverer_LT",
    ServiceProvider_Coverer_PL = "ServiceProvider_Coverer_PL",
    ServiceProvider_Coverer_SE = "ServiceProvider_Coverer_SE",
    ServiceProvider_Coverer_SK = "ServiceProvider_Coverer_SK",
    ServiceProvider_DE = "ServiceProvider_DE",
    ServiceProvider_DK = "ServiceProvider_DK",
    ServiceProvider_FI = "ServiceProvider_FI",
    ServiceProvider_Forwarder_DE = "ServiceProvider_Forwarder_DE",
    ServiceProvider_Forwarder_DK = "ServiceProvider_Forwarder_DK",
    ServiceProvider_Forwarder_FI = "ServiceProvider_Forwarder_FI",
    ServiceProvider_Forwarder_LT = "ServiceProvider_Forwarder_LT",
    ServiceProvider_Forwarder_PL = "ServiceProvider_Forwarder_PL",
    ServiceProvider_Forwarder_SE = "ServiceProvider_Forwarder_SE",
    ServiceProvider_Forwarder_SK = "ServiceProvider_Forwarder_SK",
    ServiceProvider_Harvester_DE = "ServiceProvider_Harvester_DE",
    ServiceProvider_Harvester_DK = "ServiceProvider_Harvester_DK",
    ServiceProvider_Harvester_FI = "ServiceProvider_Harvester_FI",
    ServiceProvider_Harvester_LT = "ServiceProvider_Harvester_LT",
    ServiceProvider_Harvester_PL = "ServiceProvider_Harvester_PL",
    ServiceProvider_Harvester_SE = "ServiceProvider_Harvester_SE",
    ServiceProvider_Harvester_SK = "ServiceProvider_Harvester_SK",
    ServiceProvider_LT = "ServiceProvider_LT",
    ServiceProvider_PL = "ServiceProvider_PL",
    ServiceProvider_SE = "ServiceProvider_SE",
    ServiceProvider_SK = "ServiceProvider_SK",
    Grower_SugarCane = "Grower_SugarCane",
    TranslationAdmin = "TranslationAdmin",
    UserAdministrator = "UserAdministrator",
    UserReader = "UserReader",
    Shop = "Shop",
    Shop_Admin = "Shop_Admin",
    Shop_Admin_DE = "Shop_Admin_DE",
    Shop_Admin_DK = "Shop_Admin_DK",
    Shop_Admin_FI = "Shop_Admin_FI",
    Shop_Admin_LT = "Shop_Admin_LT",
    Shop_Admin_PL = "Shop_Admin_PL",
    Shop_Admin_SE = "Shop_Admin_SE",
    Shop_Admin_SK = "Shop_Admin_SK",
    Shop_Customer_Feed = "Shop_Customer_Feed",
    Shop_Customer_Feed_DE = "Shop_Customer_Feed_DE",
    Shop_Customer_Feed_DK = "Shop_Customer_Feed_DK",
    Shop_Customer_Feed_FI = "Shop_Customer_Feed_FI",
    Shop_Customer_Feed_LT = "Shop_Customer_Feed_LT",
    Shop_Customer_Feed_PL = "Shop_Customer_Feed_PL",
    Shop_Customer_Feed_SE = "Shop_Customer_Feed_SE",
    Shop_Customer_Feed_SK = "Shop_Customer_Feed_SK",
    Shop_DE = "Shop_DE",
    Shop_DK = "Shop_DK",
    Shop_FI = "Shop_FI",
    Shop_LT = "Shop_LT",
    Shop_PL = "Shop_PL",
    Shop_SE = "Shop_SE",
    Shop_SK = "Shop_SK",
    ServiceProvider_Cleaner = "ServiceProvider_Cleaner",
    ServiceProvider_Harverster = "ServiceProvider_Harverster",
    ServiceProvider_Coverer = "ServiceProvider_Coverer",
    ServiceProvider_Forwarder = "ServiceProvider_Forwarder",
    Grower_Bassum = "Grower_Bassum",
    Grower_SelfDelivery = "Grower_SelfDelivery",
    Grower_SelfDelivery_DE = "Grower_SelfDelivery_DE",
    Grower_SelfDelivery_DK = "Grower_SelfDelivery_DK",
    Grower_SelfDelivery_FI = "Grower_SelfDelivery_FI",
    Grower_SelfDelivery_LT = "Grower_SelfDelivery_LT",
    Grower_SelfDelivery_PL = "Grower_SelfDelivery_PL",
    Grower_SelfDelivery_SE = "Grower_SelfDelivery_SE",
    Grower_SelfDelivery_SK = "Grower_SelfDelivery_SK",
    Internal_Employee = "Internal_Employee",
    Internal_Employee_DE = "Internal_Employee_DE",
    Internal_Employee_DK = "Internal_Employee_DK",
    Internal_Employee_FI = "Internal_Employee_FI",
    Internal_Employee_LT = "Internal_Employee_LT",
    Internal_Employee_PL = "Internal_Employee_PL",
    Internal_Employee_SE = "Internal_Employee_SE",
    Internal_Employee_SK = "Internal_Employee_SK",
    Internal_Employee_Beet = "Internal_Employee_Beet",
    Internal_Employee_Beet_DE = "Internal_Employee_Beet_DE",
    Internal_Employee_Beet_DK = "Internal_Employee_Beet_DK",
    Internal_Employee_Beet_FI = "Internal_Employee_Beet_FI",
    Internal_Employee_Beet_LT = "Internal_Employee_Beet_LT",
    Internal_Employee_Beet_PL = "Internal_Employee_Beet_PL",
    Internal_Employee_Beet_SE = "Internal_Employee_Beet_SE",
    Internal_Employee_Beet_SK = "Internal_Employee_Beet_SK",
    Internal_Employee_Support_DE = "Internal_Employee_Support_DE",
    Internal_Employee_Support_DK = "Internal_Employee_Support_DK",
    Internal_Employee_Support_FI = "Internal_Employee_Support_FI",
    Internal_Employee_Support_LT = "Internal_Employee_Support_LT",
    Internal_Employee_Support_PL = "Internal_Employee_Support_PL",
    Internal_Employee_Support_SE = "Internal_Employee_Support_SE",
    Internal_Employee_Support_SK = "Internal_Employee_Support_SK",
    TranslationAdmin_All = "TranslationAdmin_All",
    TranslationAdmin_EN = "TranslationAdmin_EN",
    TranslationAdmin_DE = "TranslationAdmin_DE",
    TranslationAdmin_DK = "TranslationAdmin_DK",
    TranslationAdmin_FI = "TranslationAdmin_FI",
    TranslationAdmin_LT = "TranslationAdmin_LT",
    TranslationAdmin_PL = "TranslationAdmin_PL",
    TranslationAdmin_SE = "TranslationAdmin_SE",
    TranslationAdmin_SK = "TranslationAdmin_SK",
    DeliveryPlanAdmin = "DeliveryPlanAdmin",
    PageAdmin = "PageAdmin",
}

export interface CropConnectRoleDefinitionsListCropConnectApiResponse {
    data?: CropConnectRoleDefinitions[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface CropConnectTaskDto {
    accessId?: string | undefined;
    type: TaskType;
    startDate?: string | undefined;
    endDate?: string | undefined;
    propertyBag?: { [key: string]: any; } | undefined;
    assignedToBusinessPartners?: string[] | undefined;
    assignedToRoles?: CropConnectRoleDefinitions[] | undefined;
    assignedToCountries?: CropConnectCountry[] | undefined;
}

export interface CropConnectTaskDtoCropConnectApiResponse {
    data?: CropConnectTaskDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface CropConnectTaskDtoListCropConnectApiResponse {
    data?: CropConnectTaskDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface CropConnectUserDto {
    id?: string | undefined;
    displayName?: string | undefined;
    activeBpNumber?: string | undefined;
    nordzuckerInternalUserId?: string | undefined;
    email?: string | undefined;
}

export interface CropConnectUserDtoCropConnectApiResponse {
    data?: CropConnectUserDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DeliveryEntitlementsDto {
    deliveryEntitlementTotal?: number;
    contractedAmount?: number;
    availableAmount?: number;
    year?: string | undefined;
    deliveryEntitlementFactorNzHolding?: FactorDTO;
    deliveryEntitlementFactorUnion?: FactorDTO;
}

export interface DeliveryEntitlementsDtoCropConnectApiResponse {
    data?: DeliveryEntitlementsDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DeliveryPlanDto {
    businessPartnerNumber: string | undefined;
    campaignYear?: number;
    notVisibleMessage?: string | undefined;
    deliveryPlanVisible?: boolean;
    plannedDeliveries?: DeliveryPlanItemDto[] | undefined;
}

export interface DeliveryPlanDtoListCropConnectApiResponse {
    data?: DeliveryPlanDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DeliveryPlanItemDto {
    loadDate?: string | undefined;
    loadWeek?: number;
    roundSequenceNumber?: string | undefined;
    fieldName?: string | undefined;
    loadQuantity?: number;
    pileCoverer?: string | undefined;
    pileCovererName?: string | undefined;
    transportingCompany?: string | undefined;
    transportingCompanyName?: string | undefined;
    isSelfLoader?: boolean;
    isSelfCoverer?: boolean;
    exactDateVisible?: boolean;
    acreage?: number | undefined;
}

export interface DeliveryPlanServiceProviderDataDto {
    serviceProvider?: string | undefined;
    additionalInfo?: string | undefined;
}

export interface DeliveryPlanServiceProviderDataDtoCropConnectApiResponse {
    data?: DeliveryPlanServiceProviderDataDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DeliveryPlanSettingsDto {
    applicableTo?: CropConnectRoleDefinitions;
    campaignYear?: number;
    notVisibleMessage?: string | undefined;
    daysBeforeExactDeliveryDateVisible?: number;
    deliveryPlanVisible?: boolean;
}

export interface DeliveryPlanSettingsDtoCropConnectApiResponse {
    data?: DeliveryPlanSettingsDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DeliveryPlanSettingsDtoListCropConnectApiResponse {
    data?: DeliveryPlanSettingsDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface Disease {
    id?: number;
    englishName?: string | undefined;
}

export enum DocumentFolder {
    Unknown = "Unknown",
    MyBenchmark = "MyBenchmark",
    MyBusinessInfoBeet = "MyBusinessInfoBeet",
    MyBusinessInfoLogistic = "MyBusinessInfoLogistic",
    MyCampaign = "MyCampaign",
    MyContactData = "MyContactData",
    MyContract = "MyContract",
    MyDataExportSupportData = "MyDataExportSupportData",
    MyDeliveries = "MyDeliveries",
    MyNewsletter = "MyNewsletter",
    MyOrders = "MyOrders",
    MyPayments = "MyPayments",
    MyTransportGroup = "MyTransportGroup",
}

export interface DocumentSnapshotDTORetrievalResult {
    availableItemsCount?: number;
    documents?: DocumentSnapshotDto[] | undefined;
}

export interface DocumentSnapshotDTORetrievalResultCropConnectApiResponse {
    data?: DocumentSnapshotDTORetrievalResult;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface DocumentSnapshotDto {
    additionalData?: { [key: string]: string; } | undefined;
    id?: string | undefined;
    businessPartnerNumber?: string | undefined;
    name?: string | undefined;
    category?: string | undefined;
    folderString?: string | undefined;
    documentFolder?: DocumentFolder;
    type?: string | undefined;
    fiscalYear?: string | undefined;
    campaignYear?: string | undefined;
    creationDate?: string | undefined;
    postingDate?: string | undefined;
    read?: boolean;
}

export interface DocumentSnapshotDtoListCropConnectApiResponse {
    data?: DocumentSnapshotDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface EffectiveRoleAssignmentsDto {
    cropConnectUserId?: string | undefined;
    assignments?: RoleAssignmentDto[] | undefined;
    isAccessOnBehalf?: boolean;
}

export interface EffectiveRoleAssignmentsDtoCropConnectApiResponse {
    data?: EffectiveRoleAssignmentsDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface ErrorDto {
    message?: string | undefined;
    operationId?: string | undefined;
}

export interface FactorDTO {
    name?: string | undefined;
    value?: number | undefined;
    year?: string | undefined;
}

export interface FeedbackDto {
    accessId?: string | undefined;
    agriCenterId?: string | undefined;
    body?: string | undefined;
    createdDate?: string;
}

export interface FeedbackDtoCropConnectApiResponse {
    data?: FeedbackDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface File {
}

export interface GeneralDocumentDto {
    accessId: string | undefined;
    parent: string | undefined;
    parentHeadline: string | undefined;
    ecmDocumentId: number;
    visibleFor: string[] | undefined;
    propertyBag?: { [key: string]: any; } | undefined;
}

export interface GeneralDocumentDtoListCropConnectApiResponse {
    data?: GeneralDocumentDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface GeneralDocumentFolderCoverDto {
    id: number;
    name: string | undefined;
}

export interface GeneralDocumentFolderDto {
    id?: number | undefined;
    name: string | undefined;
    subFolders?: GeneralDocumentFolderCoverDto[] | undefined;
    documents?: SelectableGeneralDocumentDto[] | undefined;
}

export interface GeneralDocumentFolderDtoCropConnectApiResponse {
    data?: GeneralDocumentFolderDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface GeneralDocumentLightDto {
    accessId: string | undefined;
    parent: string | undefined;
    parentHeadline?: string | undefined;
    ecmDocumentId: number;
    propertyBag?: { [key: string]: any; } | undefined;
}

export interface GeneralDocumentLightDtoCropConnectApiResponse {
    data?: GeneralDocumentLightDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface GeneralDocumentLightDtoListCropConnectApiResponse {
    data?: GeneralDocumentLightDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface GeoPosition {
    altitude?: number | undefined;
    longitude?: number;
    latitude?: number;
    readonly count?: number;
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Found = "Found",
    SeeOther = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    RedirectKeepVerb = "RedirectKeepVerb",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export interface InsectMonitoringTime {
    insectId?: number;
    startWeek?: number;
    endWeek?: number;
}

export interface MonitoringDiseaseMetaDto {
    monitoringWeeksByCountry?: MonitoringWeeksByCountry | undefined;
    diseases?: Disease[] | undefined;
}

export interface MonitoringDiseaseMetaDtoCropConnectApiResponse {
    data?: MonitoringDiseaseMetaDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringInsect {
    id?: number;
    latinName?: string | undefined;
    englishName?: string | undefined;
    imageUrl?: string | undefined;
}

export interface MonitoringInsectMetaDto {
    insects?: MonitoringInsect[] | undefined;
    relevantPlantStages?: PlantStage[] | undefined;
    monitoringWeeksByCountry?: monitoringWeeksByCountry | undefined;
}

export interface MonitoringInsectMetaDtoCropConnectApiResponse {
    data?: MonitoringInsectMetaDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringLocationDto {
    campaignYear?: string | undefined;
    name?: string | undefined;
    country?: CropConnectCountry;
    beetVariety?: string | undefined;
    factory?: string | undefined;
    note?: string | undefined;
    geoPosition?: GeoPosition;
}

export interface MonitoringLocationDtoListCropConnectApiResponse {
    data?: MonitoringLocationDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringPersonDto {
    campaignYear?: string | undefined;
    bpNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    note?: string | undefined;
    countries?: CropConnectCountry[] | undefined;
    doesLocationManagement?: boolean;
    doesDiseaseMonitoring?: boolean;
    doesInsectMonitoring?: boolean;
}

export interface MonitoringPersonDtoCropConnectApiResponse {
    data?: MonitoringPersonDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringPersonDtoListCropConnectApiResponse {
    data?: MonitoringPersonDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringResultsDiseasesDTO {
    campaignYear?: string | undefined;
    date?: string;
    calendarWeek?: number;
    plantStageId?: number;
    locationId?: string | undefined;
    lastTreatmentDate?: string | undefined;
    numberOfTreatments?: number;
    diseasePercentages?: { [key: string]: number; } | undefined;
    severityLevel?: number;
    createdBy?: string | undefined;
    createdOn?: string;
}

export interface MonitoringResultsDiseasesListDto {
    monitoringResultsDiseases?: MonitoringResultsDiseasesDTO[] | undefined;
}

export interface MonitoringResultsDiseasesListDtoCropConnectApiResponse {
    data?: MonitoringResultsDiseasesListDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringResultsInsectsDTO {
    campaignYear?: string | undefined;
    calendarWeek?: number;
    plantStageId?: number;
    locationId?: string | undefined;
    lastTreatmentDate?: string | undefined;
    numberOfTreatments?: number;
    insectData?: { [key: string]: number; } | undefined;
    createdBy?: string | undefined;
    createdOn?: string;
    severityLevel?: number;
}

export interface MonitoringResultsInsectsListDto {
    monitoringResultsInsects?: MonitoringResultsInsectsDTO[] | undefined;
}

export interface MonitoringResultsInsectsListDtoCropConnectApiResponse {
    data?: MonitoringResultsInsectsListDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface MonitoringWeek {
    diseaseIds?: number[] | undefined;
    startWeek?: number;
    endWeek?: number;
}

/** Request body for getting the id of B2C user */
export interface ObjectIdRequestBody {
    /** Email of the user */
    email: string | undefined;
}

export interface PlantStage {
    id?: number;
    translationKey?: string | undefined;
}

export interface PowerBiEmbedTokenDto {
    embedToken?: string | undefined;
    reportId?: string;
}

export interface PowerBiEmbedTokenDtoCropConnectApiResponse {
    data?: PowerBiEmbedTokenDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface RoleAssignmentDto {
    businessPartnerNumber?: string | undefined;
    roles?: CropConnectRoleDefinitions[] | undefined;
    type?: RoleAssignmentType;
    businessPartnerCountryTwoLetterIsoCode?: string | undefined;
}

export enum RoleAssignmentType {
    None = "None",
    Global = "Global",
    BusinessPartner = "BusinessPartner",
}

export interface RoleAssignmentsDto {
    id?: string | undefined;
    cropConnectUserId?: string | undefined;
    assignments?: RoleAssignmentDto[] | undefined;
}

export interface RoleAssignmentsDtoCropConnectApiResponse {
    data?: RoleAssignmentsDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SampleFrequencyDataBoxDto {
    accessId?: string | undefined;
    samplingFrequency: SamplingFrequencyRecord[] | undefined;
}

export interface SampleFrequencyDataBoxDtoCropConnectApiResponse {
    data?: SampleFrequencyDataBoxDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SamplingFrequencyRecord {
    year?: number | undefined;
    samplingClass?: number | undefined;
    deliveryCategory?: string | undefined;
}

export interface SelectableBusinessPartnerDto {
    accessId: string | undefined;
    businessPartnerNumber?: string | undefined;
    displayName?: string | undefined;
    activated?: boolean;
    initialized?: boolean;
}

export interface SelectableGeneralDocumentDto {
    id: number;
    name: string | undefined;
    mimeType: string | undefined;
}

/** Request model for sending the OTP email */
export interface SendOtpEmailRequestBody {
    /** Target email */
    email: string | undefined;
    /** Generated otp code */
    otp: string | undefined;
}

export interface StringCropConnectApiResponse {
    data?: string | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SurveyDto {
    accessId?: string | undefined;
    name: string | undefined;
    headline?: string | undefined;
    questions?: SurveyQuestionDto[] | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    active?: boolean;
    type: SurveyType;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface SurveyDtoCropConnectApiResponse {
    data?: SurveyDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SurveyDtoListCropConnectApiResponse {
    data?: SurveyDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SurveyFormDto {
    businessPartnerNumber: string | undefined;
    surveyId: string | undefined;
    answers?: { [key: string]: any; } | undefined;
    questions?: SurveyQuestionDto[] | undefined;
    additionalData?: { [key: string]: any; } | undefined;
    filledBy?: string | undefined;
    readonly filledOut?: boolean | undefined;
    surveyName?: string | undefined;
    surveyHeadline?: string | undefined;
    surveyAdditionalData?: { [key: string]: any; } | undefined;
}

export interface SurveyFormDtoCropConnectApiResponse {
    data?: SurveyFormDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface SurveyQuestionDto {
    accessId?: string | undefined;
    properties?: { [key: string]: any; } | undefined;
    order?: number;
}

export interface SurveyQuestionDtoCropConnectApiResponse {
    data?: SurveyQuestionDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export enum SurveyType {
    Unknown = "Unknown",
    RedCert = "RedCert",
}

export enum TaskType {
    NONE = "NONE",
    FILL_RED_CERT_SURVEY = "FILL_RED_CERT_SURVEY",
    SURVEY = "SURVEY",
    GENERAL_DOCUMENT = "GENERAL_DOCUMENT",
    FIELD_MAP = "FIELD_MAP",
    EXTERNAL_URL = "EXTERNAL_URL",
    INTERNAL_URL = "INTERNAL_URL",
    ESHOP = "ESHOP",
    ECONTRACTING = "ECONTRACTING",
}

export interface TranslationDto {
    id?: CropConnectLanguages;
    value?: { [key: string]: any; } | undefined;
}

export interface TranslationDtoCropConnectApiResponse {
    data?: TranslationDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface TranslationDtoListCropConnectApiResponse {
    data?: TranslationDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

/** Roquest body for updating the delivery plan settings */
export interface UpdateDeliveryPlanSettingsRequestBody {
    applicableTo: CropConnectRoleDefinitions;
    /** Message to show when the delivery plan is not visible */
    notVisibleMessage?: string | undefined;
    /** Number of days when to show the exact delivery date */
    daysBeforeExactDeliveryDateVisible: number;
    /** If the delivery plan is visible <seealso cref="P:Nordzucker.CropConnect.WebApi.Models.Requests.DeliveryPlan.UpdateDeliveryPlanSettingsRequestBody.NotVisibleMessage" /> */
    deliveryPlanVisible: boolean;
}

/** Used for adding or updating the general document */
export interface UpdateGeneralDocumentRequest {
    /** Id of the parent folder */
    parentFolderId?: number | undefined;
    /** The document id */
    documentId?: number | undefined;
    /** Bp numbers or roles for whom the document should be visible. Should be formatted as JSON array of strings */
    visibleFor?: string[] | undefined;
    /** Properties of the document. Should be formatted as JSON object */
    properties?: { [key: string]: any; } | undefined;
}

export interface UpdateMonitoringPersonParameters {
    campaignYear?: string | undefined;
    bpNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    note?: string | undefined;
    countries?: CropConnectCountry[] | undefined;
    doesLocationManagement?: boolean;
    doesDiseaseMonitoring?: boolean;
    doesInsectMonitoring?: boolean;
}

/** Request body for updating the survey question */
export interface UpdateSurveyQuestionRequest {
    /** Properties of the question. */
    properties?: { [key: string]: any; } | undefined;
    /** Question order */
    order?: number;
}

export interface UpdateTranslationValueParameters {
    language?: CropConnectLanguages;
    key?: string | undefined;
    value?: string | undefined;
}

/** Body of the request used for adding the widgets */
export interface UpdateWidgetRequest {
    widgetType: WidgetType;
    /** Order of the widgets */
    order: number;
    /** Property bag */
    propertyBag?: { [key: string]: any; } | undefined;
}

export interface WeatherDto {
    todaysForecast?: string | undefined;
    threeDayForecast?: string | undefined;
}

export interface WeatherDtoCropConnectApiResponse {
    data?: WeatherDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface WidgetDto {
    accessId?: string | undefined;
    parent: string | undefined;
    type: WidgetType;
    propertyBag?: { [key: string]: any; } | undefined;
    order: number;
}

export interface WidgetDtoCropConnectApiResponse {
    data?: WidgetDto;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export interface WidgetDtoListCropConnectApiResponse {
    data?: WidgetDto[] | undefined;
    error?: ErrorDto;
    readonly success?: boolean;
    statusCode?: HttpStatusCode;
}

export enum WidgetType {
    UNKNOWN = "UNKNOWN",
    GENERAL_DOCUMENT_LIST = "GENERAL_DOCUMENT_LIST",
    GENERAL_DOCUMENT_BANNER = "GENERAL_DOCUMENT_BANNER",
}

export interface MonitoringWeeksByCountry {
    None?: MonitoringWeek;
    DE?: MonitoringWeek;
    DK?: MonitoringWeek;
    SE?: MonitoringWeek;
    PL?: MonitoringWeek;
    LT?: MonitoringWeek;
    SK?: MonitoringWeek;
    FI?: MonitoringWeek;
    LV?: MonitoringWeek;
}

export interface monitoringWeeksByCountry {
    None?: InsectMonitoringTime[];
    DE?: InsectMonitoringTime[];
    DK?: InsectMonitoringTime[];
    SE?: InsectMonitoringTime[];
    PL?: InsectMonitoringTime[];
    LT?: InsectMonitoringTime[];
    SK?: InsectMonitoringTime[];
    FI?: InsectMonitoringTime[];
    LV?: InsectMonitoringTime[];
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

//Export with the preconfigured axios client
//transformResponse: [] is required so that the axios doesn't do it automatically (code generator generates JSON.parse and it threw exception)
const axiosClient = axios.create({transformResponse: []});

axiosClient.interceptors.response.use(undefined, (error: any) => {
  if ((error as AxiosError).response?.data) {
    let casted = error as AxiosError;
    try {
      const parsedResponse = JSON.parse(casted.response?.data as any);
      if (parsedResponse?.error as ErrorDto) {
        console.error(
          `Error invoking request ${casted?.request?.responseURL}. See operation_Id: ${(parsedResponse?.error as ErrorDto).operationId}`
        );
      }
    } catch (e) {}
  }
  return Promise.reject(error);
});

/** Used in error handling (will be thrown as exception if the response status code has been documented in the swagger)*/
export interface ErrorBase {
  error?: ErrorDto;
  readonly success?: boolean;
  statusCode?: HttpStatusCode;
}

export const cropConnectApiClient = new CropConnectApiClient(API_CONFIG.BASE_URL, axiosClient);

      
// Feature Names - automatically generated from CropConnectFeatureNames.cs
export enum CropConnectFeatureNames {
  /** Feature flag: TestFeature */
  TestFeature = "TestFeature",
};